import type { ReactNode } from "react";
import styles from "./Overlay.module.css";
import { OverlayShell } from "./OverlayShell";

interface ModalProps {
  open: boolean;
  onDismiss: () => void;
  title: string;
  children: ReactNode;
  /** Mobile approval modal + a few others want the blur. Off by default. */
  blurScrim?: boolean;
  /** Renders a Close button in the header. Defaults to true. Approval
   *  modal sets this to false in favor of an explicit "Cancel request". */
  showClose?: boolean;
}

/**
 * Modal — 420px centered, scrim (optional 4px blur), focus trapped,
 * close on Escape / scrim click / Close button.
 *
 * The Mobile-approval modal (§8) uses `blurScrim={true}` and
 * `showClose={false}`.
 */
export function Modal({
  open,
  onDismiss,
  title,
  children,
  blurScrim = false,
  showClose = true,
}: ModalProps) {
  return (
    <OverlayShell
      open={open}
      onDismiss={onDismiss}
      ariaLabel={title}
      variant="modal"
      scrimBlur={blurScrim}
    >
      <div className={styles.header}>
        <h2 className={styles.title}>{title}</h2>
        {showClose ? (
          <button
            type="button"
            className={styles.close}
            onClick={onDismiss}
            aria-label="Close"
          >
            Close
          </button>
        ) : null}
      </div>
      <div style={{ marginTop: 16 }}>{children}</div>
    </OverlayShell>
  );
}
